import axios from 'axios';
import * as config from '../constants/configuration';



import {
    OPEN_DIALOG, SET_SAVE_STATE_PENDING
} from '../constants/action_types';


export function getData(uri, actionType, meta, showError = true) {
    return (dispatch, getState) => {

        dispatch({ type: actionType, payload: uri, meta: meta })

        let token = getState().oidc.user ? getState().oidc.user.access_token : "";

        return axios.get(config.API_URI() + uri,
            {
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        ).then((response) => {

            console.log('success ' + actionType);
            // setTimeout(() => {
            dispatch({ type: actionType + "_SUCCESS", payload: response, meta: meta })
            // }, 1500)

        }).catch((error) => {
            if (error.response) {
                const errorMessage = error.response.data.message !== undefined ? error.response.data.message : error.response.data;
                if (showError) {
                    dispatch({
                        type: OPEN_DIALOG,
                        modalType: 'SimpleMessage',
                        modalProps: { message: errorMessage, exception: error.response.data.ex ? error.response.data.ex : undefined },
                        dialogid: 'error_getting_data '
                    });
                }
                dispatch({ type: actionType + "_FAILURE", error: errorMessage });
            }
        });
    }
}

export function postData(uri, actionType, data, message, thenHandler, showError = true, errorHandler) {
    return (dispatch, getState) => {
        dispatch({ type: actionType, payload: data })
        let token = getState().oidc.user ? getState().oidc.user.access_token : "";
        axios.post(config.API_URI() + uri, data,
            {
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        ).then((response) => {
            dispatch({ type: actionType + "_SUCCESS", payload: response });
            if (message !== undefined) {
                dispatch({
                    type: OPEN_DIALOG,
                    modalType: 'SimpleMessage',
                    modalProps: { message: message },
                    dialogid: 'success_post_' + actionType
                });
            }
            if (thenHandler !== undefined) thenHandler(response);
            else dispatch({ type: SET_SAVE_STATE_PENDING, payload: false });
        }).catch((error) => {
            if (errorHandler !== undefined) errorHandler(error.response)
            if (error.response) {
                const errorMessage = error.response.data.message !== undefined ? error.response.data.message : typeof error.response.data === 'string' ? error.response.data : JSON.stringify(error.response.data);
                if (showError) {
                    dispatch({
                        type: OPEN_DIALOG,
                        modalType: 'SimpleMessage',
                        modalProps: { message: errorMessage, exception: error.response.data.ex ? error.response.data.ex : undefined },
                        dialogid: 'error_getting_data '
                    });
                }
                dispatch({ type: actionType + "_FAILURE", error: errorMessage });
            }
        });
    };
}

export function putData(uri, actionType, data, id, message, thenHandler, showError = true, errorHandler) {
    return (dispatch, getState) => {
        dispatch({ type: actionType, payload: data })
        let token = getState().oidc.user ? getState().oidc.user.access_token : "";
        axios.put(config.API_URI() + uri + '/' + id, data,
            {
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        ).then((response) => {
            dispatch({ type: actionType + "_SUCCESS", payload: response });
            if (message !== undefined) {
                dispatch({
                    type: OPEN_DIALOG,
                    modalType: 'SimpleMessage',
                    modalProps: { message: message },
                    dialogid: 'success_put_' + actionType
                });
            }
            if (thenHandler !== undefined) thenHandler(response)
            else dispatch({ type: SET_SAVE_STATE_PENDING, payload: false });
        }).catch((error) => {
            if (errorHandler !== undefined) errorHandler(error.response)
            if (error.response) {
                const errorMessage = error.response.data.message !== undefined ? error.response.data.message : typeof error.response.data === 'string' ? error.response.data : JSON.stringify(error.response.data);
                if (showError) {
                    dispatch({
                        type: OPEN_DIALOG,
                        modalType: 'SimpleMessage',
                        modalProps: { message: errorMessage, exception: error.response.data.ex ? error.response.data.ex : undefined },
                        dialogid: 'error_getting_data '
                    });
                }
                dispatch({ type: actionType + "_FAILURE", error: errorMessage });
            }
        });
    };
}